import React from "react";

function NoTransaction() {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%',
      minHeight: '300px',
      width: '100%'
    }}>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        gap: '16px'
      }}>
        <div style={{
          width: '80px',
          height: '80px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
          <img 
            src="./images/doc_icon.png" 
            alt="No transactions" 
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
              opacity: '0.6'
            }}
          />
        </div>
        <p style={{
          color: '#888',
          fontSize: '16px',
          fontWeight: '500',
          margin: '0'
        }}>
          No Transaction found
        </p>
      </div>
    </div>
  );
}

export default NoTransaction;